module.exports = __webpack_public_path__ + "img/flot6.45504b0c.svg";